import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ContentWrapper, ContestResults } from '../../components';
import { useQuizQuery } from '../../queries';
import { AppRoutes } from '../../types/routes';
import { isContestEnded, isContestStarted } from '../../utils';

export const QuizPage = () => {
  const navigate = useNavigate();
  const { data: quizStatus, isLoading, isError } = useQuizQuery();

  const shouldNavigateToQuestion =
    isContestStarted() &&
    !isContestEnded() &&
    (quizStatus?.total_number_of_responses ?? 0) < 50 &&
    !isLoading &&
    !isError;

  useEffect(() => {
    const timerId = setInterval(() => {
      if (shouldNavigateToQuestion) {
        navigate(`${AppRoutes.Quiz}/${(quizStatus?.total_number_of_responses ?? 0) + 1}`);
        clearInterval(timerId);
      }
    }, 1000);

    return () => clearInterval(timerId);
  }, [shouldNavigateToQuestion, navigate, quizStatus?.total_number_of_responses]);

  useEffect(() => {
    if (!isContestStarted() || isContestEnded()) {
      navigate(AppRoutes.Home, { replace: true });
    }
  }, [navigate]);

  return (
    <ContentWrapper>
      {shouldNavigateToQuestion && (
        <div className="flex flex-col justify-center gap-3 text-center py-6 sm:py-8">
          <div className="text-xl text-bold">Vă rugăm așteptați!</div>
          <div>
            Veți fi redirecționat către pagina cu întrebări. În cazul în care nu se întâmplă acest
            lucru, vă rugăm dați click{' '}
            <Link className="text-primary underline" to={`${AppRoutes.Quiz}/1`}>
              aici
            </Link>
            .
          </div>
        </div>
      )}
      <ContestResults />
    </ContentWrapper>
  );
};
